export default __webpack_public_path__ + "static/media/NinetyOne.e447330c.png";